import { z } from 'zod';
import { REQUEST_VIEWS } from '@/api/requests';

/** Parámetros de URL de Solicitudes (los comparten el panel y el portal): vista, tipo, prioridad y la solicitud abierta. Nunca datos de la persona. */
export const requestsSearchFields = {
  view: z.enum(REQUEST_VIEWS).optional().catch(undefined),
  kind: z
    .string()
    .regex(/^[a-z][a-z0-9_]{0,29}$/)
    .optional()
    .catch(undefined),
  priority: z.enum(['high', 'medium', 'low']).optional().catch(undefined),
  request: z.string().optional(),
};
export const requestsSearchSchema = z.object({ tenant: z.string().optional(), ...requestsSearchFields });
export type RequestsRouteSearch = z.infer<typeof requestsSearchSchema>;
